import React from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

import { LangType, StoreType } from "client/store"
import { Empty } from "client/components"

export const DateFormatterString = (dateUnformatted: Date, lang: LangType) => {
    const date = new Date(dateUnformatted)
    const year = date.getFullYear().toString()
    const monthIndex = date.getMonth().toString()
    const month = lang[`month_${monthIndex}` as keyof LangType]
    const monthShort = lang[`monthShort_${monthIndex}` as keyof LangType]
    const day = date.getDate().toString()

    const hours = date.getHours().toString()
    const minutes = date.getMinutes()
    const minutesFormatted = (minutes > 9) ? minutes.toString() : `0${minutes}`

    return {
        day,
        month,
        monthShort,
        year,
        date: `${month} ${day}, ${year}`,
        time: `${hours}:${minutesFormatted}`,
    }
}

interface SpanProps {
    defaultStyles?: boolean
}
export interface DateFormatterProps extends SpanProps {
    date: Date
    showTime?: boolean
}

export const DateFormatterSpan = styled.span<SpanProps>`
    color: ${(props) => (props.defaultStyles ? "inherit" : props.theme.dateFormatterColor)};
    font-family: ${(props) => (props.defaultStyles ? "inherit" : props.theme.openSans)};
    font-size: ${(props) => (props.defaultStyles ? "inherit" : `${props.theme.fontSizes.sm}px`)};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`

export const DateFormatter = ({
    date = null,
    defaultStyles = false,
    showTime = true,
}: DateFormatterProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const formattedDate = DateFormatterString(date, lang)
    if (!date) return <Empty />
    return (
        <DateFormatterSpan defaultStyles={defaultStyles}>
            {showTime ? `${formattedDate.date}, ${formattedDate.time}` : formattedDate.date}
        </DateFormatterSpan>
    )
}
